import React, { Fragment, useEffect, useState } from "react";
import { Image } from "lib";
import { useDispatch, useSelector } from "react-redux";
import option from "../../assets/images/option.svg";
import show_password from "assets/images/show_password.svg";
import hide_password from "assets/images/hide_password.svg";
import "./index.scss";
import { useRef } from "react";
import {
  recursiveRead,
  setDeleteSaveData,
  setDeleteShowData,
  setShowRecursiveForm,
  setShowDataPreview,
  setAssociatedWf,
  setIsMinor,
  setIsMinorEdit,
  setIsEditMinor,
  setIsAssociated,
  setAssociateRequired,
  setCurrentFormType,
  setRecursiveFormData,
  clearRecursiveFormData,
} from "redux/recursiveReducer";
const RecursiveDataPreview = ({
  recursiveRead,
  recursiveTrigger,
  data,
  item,
  handleEditChange,
  type
}) => {
  const [maskType,setMaskType] = useState({})
  const dispatch = useDispatch();
  //fetch requestedId from the url query
  const requestedDocs = useSelector(
    (state) => state.requestedDocReducer.requestedDocs
  );
  const disableDelete = requestedDocs?.requestedFlow;
  const formData = useSelector(state => state?.formData)

  const showData = useSelector((state) => state.recursive?.showData);
  const saveData = useSelector((state) => state.recursive?.saveData);
  const isEditRecursiveForm = useSelector((state) => state.recursive?.isEditRecursiveForm);
  const showRecursiveForm = useSelector(
    (state) => state.recursive?.showRecursiveForm
  );
  const associateRequired = useSelector(
    (state) => state.recursive.associateRequired
  );
  const currentFormType = useSelector(
    (state) => state.recursive.currentFormType
  );
  const recursiveFormData = useSelector(
    (state) => state.recursive.recursiveFormData
  );

    // using this in eval dont delete
  const recursive = useSelector(state => state?.recursive)

  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
 
  const maxActiveGroup = useSelector((state) => state.userInfo.maxActiveGroup);
  const maxActiveSection = useSelector((state) => state.userInfo.maxActiveSection);
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  const primaryUser = useSelector((state) => state.userInfo?.primaryUser);
  const [isClicked, setIsClicked] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const search = window.location.search;
  const query = new URLSearchParams(search);
  const requestedId = React.useMemo(() => {
    //optimization
    return query.get("requestedId");
  }, [search, query]);
  const handleClickOutside = () => {
    setIsClicked(false);
  };
  const ref = useOutsideClick(handleClickOutside);

  const handleOptionChange = (index) => {
    setSelectedId(index);
    setIsClicked(!isClicked);
  };

  const [showMaskedText, setShowMaskedText] = useState(false)
  const inputFields = useSelector((state)=> state?.recursive?.formFields)
  const maskedText = (name) =>{
    let template = '';
    for(let i = 0; i< name.length;i++){
      template += '*'
    }
    return template
  }

  const togglePassword =(name)=>{
    setShowMaskedText(value => !value)
    if(maskType[name] == true)
      {
      let mask_type = {...maskType}
      mask_type[name] = false
      setMaskType(mask_type)
     return;
      }
    let mask_type = {...maskType}
    mask_type[name] = true
    setMaskType(mask_type)
  }

  const handleDelete = (index) => {
    if (recursiveTrigger) {
      //* check if the person deleted is applicant then delete his guardian also
      if (!saveData[index].hasOwnProperty("guardian_of")) {
        // dispatch(setAssociateRequired(true))
        let guardianIndex = -1;
        saveData.map((item, _index) => {
          if (item?.guardian_of === saveData[index]?.first_name) {
            guardianIndex = _index;
          }
        });
        if (guardianIndex !== -1) {
          dispatch(setDeleteSaveData(guardianIndex));
          dispatch(setDeleteShowData(guardianIndex));
        }
      } else {
        dispatch(setAssociateRequired(true));
      }
    }
    //* delete the index selected
    dispatch(setDeleteShowData(index));
    dispatch(setDeleteSaveData(index));
    //*clear the data so form doesnt get repopulated on delete
    dispatch(clearRecursiveFormData());
    setIsClicked(false);
  };
  
  useEffect(() => {
    //* reset redux variables to default value when all data is deleted
    if (recursiveTrigger)
      if (saveData.length === 0) {
        dispatch(setAssociateRequired(false));
        dispatch(setCurrentFormType("applicant"));
      }
  }, [saveData]);

  useEffect(() => {
    if (showData.length === 0) {
      dispatch(setShowDataPreview(false));
      dispatch(setShowRecursiveForm(true));
    }
  }, [showData]);

  const handleEdit = (index) => {
    setIsClicked(false);
    //Editing guardian data // should not do this if recurisve trigger is true
    if (recursiveTrigger) {
      if (saveData[index].hasOwnProperty("guardian_of")) {
        dispatch(setCurrentFormType("associate"));
      } else {
        dispatch(setCurrentFormType("applicant"));
      }
    }
    handleEditChange(index);
  };
  const titleCase = (s) => {
    s = s.replaceAll("_", " ");
    let res = s.charAt(0).toUpperCase() + s.slice(1);
    return res;
  };
  const mapValues = (item) => {
    if (Array.isArray(item)) {
      let resString;
      let res = item.map((_item) => _item);
      resString = res?.join(",");
      // // console.log(resString);
      return resString;
    } else if (typeof item === "object") {
      return item?.original_name;
    } else return item;
  };
  return (
    <>
      {/* Using recursive component */}
      {item?.length && item?.[1] !== true && (
        <div className="preview_item">
          {
            inputFields && inputFields?.map((data)=>{
              if(item?.[0] ==  data?.id){
               return <span className="preview_item_label">{data?.label}</span>
              }
            })
          }
          
          <div className="d-flex align-items-center p-0 justify-content-between">
            <span className="preview_item_value break-work-when-exceeds">
              {
                inputFields?.map((_item) => {
                
                  if (item?.[0] === _item?.id) {
                    if (_item?.masking_type) {
                      return showMaskedText ? mapValues(item?.[1]) : maskedText(mapValues(item?.[1]));
                    } else {
                      return mapValues(item?.[1]);
                    }
                  }
                })
              }
            </span>
            <span className="mt-0 mx-4 ">
              {
                inputFields?.some((_item) => item?.[0] === _item?.id && _item?.masking_type) && (
                  <Image
                    className='cursor-pointer'
                    imageSrc={!maskType[item[0]] || !maskType.hasOwnProperty(item[0]) ? show_password : hide_password}
                    onClick={() => togglePassword(item?.[0])}
                  />
                )
              }
            </span>
          </div>
        </div>
      )}
      
      <div className="form-container">
        {data &&
          data.map((item, index) => {
            return (
              Object.keys(item).length > 0 && (
              <div className="preview" key={index}>
                {Object.keys(item).length &&
                  Object.entries(item).map((_item, index) => {
                    if(_item[0] != 'verification_response' && _item[0] != 'signature_position' && _item[0] != 'trigger_esign_request' && _item[0] != 'co_signer' && _item[0] != 'signer_validation_name'){
                    return (
                      <Fragment key={index}>
                        <RecursiveDataPreview item={_item} />
                      </Fragment>
                    );
                   }
                  }) 
                
                }

                {!showRecursiveForm && recursiveRead ?  maxActiveGroup > 1 || maxActiveSection > 1  ? '' : ( 
                   <button
                    ref={ref}
                    className="option_button mt-2"
                    onClick={() => handleOptionChange(index)}
                  >
                    <Image imageSrc={option} className={`modal_trigger`} />
                    {isClicked && selectedId === index ? (
                      <div className="option_list shadow-sm rounded-0 border-0 px-1 mb-2 mx-0 bg-white ">
                        <button
                          disabled={
                            !loggedUserId &&
                            primaryUser?.created_by != null &&
                            !requestedId
                          }
                          onClick={() => handleEdit(index)}
                          className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey "
                        >
                          Edit
                        </button>
                        <button
                          disabled={
                            !loggedUserId &&
                            primaryUser?.created_by != null &&
                            !requestedId
                          }
                          onClick={() => handleDelete(index)}
                          className={`option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey `}
                          // ${
                          //   disableDelete && "radioDisabled"
                          // }`}
                        >
                          Delete
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </button>
                  
                ) : 
                (
                  <button
                  ref={ref}
                  className="option_button mt-2"
                  onClick={() => handleOptionChange(index)}
                  disabled ={isEditRecursiveForm}
                >
                  <Image imageSrc={option} className={`modal_trigger`} />
                  {isClicked && selectedId === index ? (
                    <div className="option_list">
                      <button
                        disabled={
                          !loggedUserId &&
                          primaryUser?.created_by != null &&
                          !requestedId
                        }
                        onClick={() => handleEdit(index)}
                        className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey "
                      >
                        Edit
                      </button>
                      <button
                        disabled={
                          !loggedUserId &&
                          primaryUser?.created_by != null &&
                          !requestedId
                        }
                        onClick={() => handleDelete(index)}
                        className={`option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey `}
                        // ${
                        //   disableDelete && "radioDisabled"
                        // }`}
                      >
                        Delete
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </button>
                )
                }

              </div>
              ) 
            );
          })}

        {/* Without using recursive function */}
        {/* {
        data && data.map((item, index) => {
          return (
            <div className='preview'>
              {
                Object.keys(item).length && Object.entries(item).map((_item, index) => {
                  return (
                    <div key={index} className="preview_item">
                      <span>{_item[0]}</span>
                      <span>{_item[1]}</span>
                    </div>
                  )
                })
              }
            </div>
          )
        })
      } */}
      </div>
    </>
  );
};



export default RecursiveDataPreview;

const useOutsideClick = (callback) => {
  const ref = useRef();
  useEffect(() => {
    const handleClick = (e) => {
      if (e.target.className !== "modal_trigger") {
        callback();
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [ref]);
  return ref;
};
